export const Config = {
  ITradeAPI: {
    baseUrl: "/api/intrade",
    createSession: "account/createSession",
    validateSession: "account/validateSession",
    logout: "account/logout",
    getConfig: "tmap/getConfiguration",
    dashboard: "tmap/dashboard",
    buyPerformance: "tmap/buyPerformance",
    closedTradePerformance: "tmap/closedTradePerformance",
    doBackTesting: "tmap/backTest",
    tradeOrders: {
      url: "tmap/placeOrder",
      message: "Order Executed Successfully!",
      errorMessage: "Failed to execute the Order. Please try again.",
    },
    preTradeCheck: "trade/preTradeCheck",
    startTrade: "trade/startTrade",
    stopTrade: "trade/stopTrade",
    startSaleProcess: "trade/startSaleProcess",
    stopSaleProcess: "trade/stopSaleProcess",
    checkSaleProcess: "trade/checkSaleProcess",
    runJob: "tmap/runJob",
    checkJobStatus: "tmap/checkJobStatus",
    getPaperTradeStatus: "trade/getPaperTradeStatus",
    closePaperTrade: "trade/closePaperTrade",
    deletePaperTradeSession: "trade/deletePaperTradeSession",
    getPaperTradeHistory: "trade/getPaperTradeHistory",
    screeningAnalyze: "screening/analyze",
    screeningMarketStatus: "screening/marketStatus",
    screeningLiveStart: "screening/live/start",
    screeningLiveStop: "screening/live/stop",
    screeningLiveStatus: "screening/live/status",
    checkPrediction: "prediction/checkPrediction",
    startPrediction: "prediction/startPrediction",
    stopPrediction: "prediction/stopPrediction",
    buyPrediction: "prediction/buyPrediction",
  },
};
